const PANEL_CONFIG = {
  shopByMood: {
    triggerSelector: '[data-shop-by-mood-trigger="true"]',
    backSelector: '[data-shop-by-mood-back]',
    panelSelector: '[data-shop-by-mood-panel]',
    itemSelector: '.mega-menu__gallery__item--shop-trigger',
    openClass: 'mega-menu__gallery--shop-by-mood-open',
    parentClass: 'shop-by-mood-panel-open',
  },
  shopAll: {
    triggerSelector: '[data-shop-all-trigger="true"]',
    backSelector: '[data-shop-all-back]',
    panelSelector: '[data-shop-all-panel]',
    itemSelector: '.mega-menu__gallery__item--shop-all-trigger',
    openClass: 'mega-menu__gallery--shop-all-open',
    parentClass: 'shop-all-panel-open',
  },
};

const PANEL_INTERACTIVE_SELECTOR = Object.values(PANEL_CONFIG)
  .flatMap(({ triggerSelector, backSelector, panelSelector }) => [
    triggerSelector,
    backSelector,
    panelSelector,
  ])
  .join(', ');

const OPEN_ITEM_SELECTOR = Object.values(PANEL_CONFIG)
  .map(({ itemSelector }) => `${itemSelector}.is-open`)
  .join(', ');

const FIRST_LEVEL_CLASS = 'mega-menu__gallery--shop-first-level';
const FIRST_LEVEL_VISIBLE_CLASS = 'mega-menu__gallery--shop-first-level-visible';

const stopEvent = (event) => {
  event.preventDefault();
  event.stopPropagation();
  if (typeof event.stopImmediatePropagation === 'function') {
    event.stopImmediatePropagation();
  }
};

const getPanelContext = (item) => {
  const parentMenuItem = item?.closest('.wt-page-nav-mega__item--parent');
  const wrapper = parentMenuItem?.querySelector('.wt-page-nav-mega__sublist__wrapper');
  const gallery = item?.closest('.mega-menu__gallery');

  return {
    parentMenuItem,
    wrapper,
    gallery,
  };
};

const setPanelHeight = (item, isOpen) => {
  const { parentMenuItem, wrapper, gallery } = getPanelContext(item);
  if (!parentMenuItem || !wrapper) return;

  if (isOpen) {
    const currentHeight = Math.max(
      wrapper.offsetHeight || 0,
      gallery?.scrollHeight || 0,
      gallery?.getBoundingClientRect?.().height || 0,
    );

    if (currentHeight) {
      parentMenuItem.style.setProperty('--shop-by-mood-panel-height', `${Math.ceil(currentHeight)}px`);
    }
    return;
  }

  parentMenuItem.style.removeProperty('--shop-by-mood-panel-height');
};

const syncParentState = (item, isOpen, config) => {
  const { parentMenuItem, gallery } = getPanelContext(item);
  if (!parentMenuItem) return;

  setPanelHeight(item, isOpen);
  parentMenuItem.classList.toggle(config.parentClass, isOpen);

  if (gallery && gallery.classList.contains(FIRST_LEVEL_CLASS)) {
    gallery.classList.toggle(FIRST_LEVEL_VISIBLE_CLASS, !isOpen);
  }

  if (isOpen) {
    parentMenuItem.classList.add('dropdown-opened');
    document.body.classList.add('dropdown-open-desk');
  }
};

const closeCustomPanel = (item, config) => {
  if (!item || !config) return;

  const { gallery } = getPanelContext(item);
  item.classList.remove('is-open');

  if (gallery) {
    gallery.classList.remove(config.openClass);
  }

  const trigger = item.querySelector(config.triggerSelector);
  if (trigger) {
    trigger.setAttribute('aria-expanded', 'false');
  }

  syncParentState(item, false, config);
};

const closeOtherOpenPanels = (currentItem) => {
  const { gallery } = getPanelContext(currentItem);
  if (!gallery) return;

  gallery.querySelectorAll(OPEN_ITEM_SELECTOR).forEach((openItem) => {
    if (openItem === currentItem) return;

    const config = openItem.matches(PANEL_CONFIG.shopAll.itemSelector)
      ? PANEL_CONFIG.shopAll
      : PANEL_CONFIG.shopByMood;

    closeCustomPanel(openItem, config);
  });
};

const togglePanel = (trigger, config) => {
  const item = trigger.closest(config.itemSelector);
  if (!item) return;

  closeOtherOpenPanels(item);

  const { gallery } = getPanelContext(item);
  const isOpen = item.classList.toggle('is-open');

  if (gallery) {
    gallery.classList.toggle(config.openClass, isOpen);
  }

  syncParentState(item, isOpen, config);
  trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
};

document.querySelectorAll(`.${FIRST_LEVEL_CLASS}`).forEach((gallery) => {
  gallery.classList.add(FIRST_LEVEL_VISIBLE_CLASS);
});

document.addEventListener(
  'click',
  (event) => {
    for (const config of Object.values(PANEL_CONFIG)) {
      const back = event.target.closest(config.backSelector);
      if (back) {
        stopEvent(event);
        closeCustomPanel(back.closest(config.itemSelector), config);
        return;
      }
    }

    for (const config of Object.values(PANEL_CONFIG)) {
      const trigger = event.target.closest(config.triggerSelector);
      if (trigger) {
        stopEvent(event);
        togglePanel(trigger, config);
        return;
      }
    }
  },
  true,
);

document.addEventListener(
  'mousedown',
  (event) => {
    const insidePanel = event.target.closest(PANEL_INTERACTIVE_SELECTOR);
    if (insidePanel) {
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
      return;
    }

    document.querySelectorAll(OPEN_ITEM_SELECTOR).forEach((openItem) => {
      const config = openItem.matches(PANEL_CONFIG.shopAll.itemSelector)
        ? PANEL_CONFIG.shopAll
        : PANEL_CONFIG.shopByMood;

      closeCustomPanel(openItem, config);
    });
  },
  true,
);
